import moment from "moment";
import DateRangePickerComponent from "../../../components/common/CustomDateRangePicker";
import { IconButton, Box, Button, CircularProgress, FormControl, Grid, InputAdornment, MenuItem, Pagination, Paper, Select, Table, TableBody, TableCell, TableContainer, TableRow, Typography, styled } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import { useEffect, useState } from "react";
import ReportsTableHeader from "../report-table-header.component";
import { format } from "date-fns";
import AlertSkeleton from "../skeleton/alert-skeleton";
import ReportService from "../../../services/api/reports";
import ExportAlertNotificationDialog from "../../alert/export-alert-notification-dialog.component";
import {useSnackbar} from "notistack";
import ReactSelect from "react-select";
import ClearIcon from "@mui/icons-material/Clear";
import CachedIcon from "@mui/icons-material/Cached";

const filterStyles = {
    control: (styles, { isFocused }) => ({
        ...styles,
        textAlign: "left",
        backgroundColor: "#fff",
        minHeight: 20, 
        padding: "0 8px", 
        height: 34, 
        width: 280,
        fontSize: 14,
        borderColor: "rgb(122, 120, 247)",
        '&:hover': {
            borderColor: "rgb(122, 120, 247)", 
        },
        zIndex: 1200,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 1200,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999, 
    }),
    valueContainer: (styles) => ({
        ...styles,
        padding: "0px 6px",
    }),
    input: (styles) => ({
        ...styles,
        margin: 0,
        padding: 0, 
    }),
    option: (styles) => ({...styles, textAlign: "left", fontSize: 13}),
    placeholder: (styles) => ({ ...styles, color: "#3333CFCE", marginTop: "0px", fontSize: 12}), 
    dropdownIndicator: (styles) => ({
        ...styles,
        color: "rgb(122, 120, 247)", 
        marginTop: "-2px",
        '&:hover': {
            color: "rgb(122, 120, 247)",
        },
    }),
    clearIndicator: (styles) => ({
        ...styles,
        color: "rgb(122, 120, 247)", 
        marginTop: "-2px",
        '&:hover': {
            color: "rgb(122, 120, 247)", 
        },
    }),
    singleValue: (styles) => ({
        ...styles,
        color: "rgba(51, 51, 207, 0.808)",
        marginTop: "0px",
        fontSize: 13,
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        fontStyle: "italic", 
        textAlign: "start", 
        fontSize: "13px", 
    }),
}

const SmallSelect = styled(Select)(({ theme, fontColor }) => ({
    minWidth: 120,  
    height: 33,     
    fontSize: '0.875rem',  
    '.MuiSvgIcon-root': {
        color: fontColor, 
    },
    color: fontColor,
    backgroundColor: '#fff',
    border: "1px solid #7A78F7",
    "& .MuiInputBase-root": { height: 33, border: "1px solid #7A78F7", color: "#3333CFCE", backgroundColor: '#fff', width: 250, borderRadius: "5px" },
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "& .MuiSelect-select": {
        fontSize: 12,
        fontStyle: 'italic'
    },
    "& .MuiMenuItem-root": {
        fontSize: 12,
    },
    "& .Mui-selected": {
        fontSize: 12,
        fontStyle: 'italic'
    },


}));

const AlertsAndNotificationsFilterComponent = (props) => {

    const {getAlertList, alertList, isLoadingAlertList, getUserTypes, listUserTypes, headers, page, setPage, getUserEmail, emailList} = props;

    const {enqueueSnackbar} = useSnackbar();

    const [open, setOpen] = useState(false);
    const [isLoadingAlertNotification, setIsLoadingAlertNotification] = useState(false)
    const [reportID, setReportID] = useState(null);

    const [startDate, setStartDate] = useState(moment().subtract(6, 'days').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));

    const [formattedEmailList, setFormattedEmailList] = useState([]);
    const [selectedEmail, setSelectedEmail] = useState(" ");
    const [user_email, setUserEmail] = useState("");
    const [user_type, setUserType] = useState("");


    useEffect(() => { 
        getUserTypes();
        getUserEmail();
    }, [])

    useEffect(() => {
        if (emailList) {
            const formattedList = emailList?.map(email => ({
                label: email.user_email,
                value: email.user_email
            }));

            setFormattedEmailList(formattedList);
        }
    }, [emailList])

    useEffect(() => {
        const start_date = startDate;
        const end_date = endDate;


        if (start_date && end_date && !user_type && !user_email) {
            let payload = {
                report_type: 1,
                start_date: start_date,
                end_date: end_date,
                user_type: [user_type],
                user_email: [user_email]
            }

            getAlertList(payload);

        } else if (start_date && end_date && user_type && !user_email) {
            let payload = {
                report_type: 2,
                start_date: start_date,
                end_date: end_date,
                user_type: [user_type],
                user_email: [user_email]
            }

            getAlertList(payload);

        } else if (start_date && end_date && !user_type && user_email) {
            let payload = {
                report_type: 4,
                start_date: start_date,
                end_date: end_date,
                user_type: [user_type],
                user_email: [user_email]
            }

            getAlertList(payload);

        } else if (start_date && end_date && user_type && user_email) {
            let payload = {
                report_type: 3,
                start_date: start_date,
                end_date: end_date,
                user_type: [user_type],
                user_email: [user_email]
            }

            getAlertList(payload);
        }
    }, [startDate, endDate, user_type, user_email])


    const handleSelectEmail = (selectedOption) => {
        if (!selectedOption) {
            setSelectedEmail(" ");
            setUserEmail("");

        } else {
            setSelectedEmail(selectedOption);
            setUserEmail(selectedOption?.value);
        }
    }

    const handleDateRangeChange = (newStartDate, newEndDate) => {
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    }

    const handleClose = () =>{
        setOpen(false)
    }

    const handleChangeUserType = (event) => {
        setUserType(event.target.value);
    };
    

    const handleExport = (e) => {
        const start_date = startDate;
        const end_date = endDate;

        let report_type;

        if (user_type && user_email) {
            report_type = 3; 
        } else if (user_type && !user_email) {
            report_type = 2; 
        } else if (user_email && !user_type) {
            report_type = 4; 
        } else {
            report_type = 1; 
        }

        let payload = {
            start_date: start_date,
            end_date: end_date,
            user_type: [user_type],
            report_type: report_type,
            user_email: [user_email]
        }
        
        if (alertList?.length > 0) {
            setIsLoadingAlertNotification(true);

            ReportService.exportAlertAndNotifReport(payload).then((res)=>{
                console.log('get export alert and notification res here', res)
                setIsLoadingAlertNotification(false)
                setReportID(res?.data?.data?.report_id)
                setOpen(true)
            }).catch(()=>{
                setIsLoadingAlertNotification(false)
            })
            
        } else {
            enqueueSnackbar("No data to export", { 
                variant: "error",
                autoHideDuration: 3000
            });
        }
    }

    const itemsPerPage = 100;

    // Calculate the total number of pages
    const totalPages = Math.ceil((alertList?.length || 0) / itemsPerPage);

    // Get the current items to display
    const currentItems = (alertList || []).slice((page - 1) * itemsPerPage, page * itemsPerPage);


    // Handler to change page
    const handlePageChange = (event, value) => {
        setPage(value);
    }

    const handleClearUserType = (e) => {
        setUserType("");
    }

    const handleClearFilters = (e) => {
        setSelectedEmail(" ");
        setUserEmail("");
        setUserType("");
        setStartDate(moment().subtract(6, "days").format("YYYY-MM-DD"));
        setEndDate(moment().format("YYYY-MM-DD"));
    }


    return (
        <Box>
            <Grid container sx={{justifyContent: "flex-end", alignItems: "center", mt: 3}}>
                <Grid item xs={3}>
                    <Button variant="contained" sx={{height: "33px", textTransform: "none", backgroundColor: "#5959D8", color: "#fff", "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                        startIcon={<CachedIcon />} onClick={(e) => handleClearFilters(e)}
                    >
                        Clear Filters
                    </Button>
                </Grid>

                <Grid item xs={9} sx={{ display: 'flex', justifyContent: "flex-end" }}>
                    <ReactSelect
                        isRtl={false}
                        options={formattedEmailList}
                        value={selectedEmail}
                        onChange={selectedOption => handleSelectEmail(selectedOption)}
                        styles={filterStyles}
                        isClearable={true}
                        placeholder={(selectedEmail != " ") ? null : "Select User Email"}
                        noOptionsMessage={() => "No matching email found."} 
                        menuPortalTarget={document.body} 
                        menuPosition="fixed"
                    />

                    &nbsp;&nbsp;&nbsp;&nbsp;

                    <FormControl sx={{ width: 250 }}>
                        <SmallSelect
                            value={user_type}
                            onChange={handleChangeUserType}
                            displayEmpty
                            fontColor={'#5d5ed8'}
                            startAdornment={
                                <InputAdornment position="start">
                                    <p style={{ fontSize: 12, margin: 0, color: "#3333CFCE", fontWeight: 'bold' }}>
                                        User Type:
                                    </p>
                                </InputAdornment>
                            }
                            endAdornment={user_type && 
                                (
                                    <InputAdornment position="end">
                                        <IconButton sx={{mr: "12px"}}
                                            size="small"
                                            onClick={(e) => handleClearUserType(e)}
                                        >
                                            <ClearIcon sx={{color: "#3333CFCE", fontSize: 16}} />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }
                        >
                            <MenuItem value="" disabled sx={{ fontSize: 12 }}>
                                <em>Select User Type</em>
                            </MenuItem>
                            
                            {listUserTypes?.map((list, index)=>{
                                return(
                                    <MenuItem key={index} value={list} sx={{ fontSize: 12 }}>
                                        {list}
                                    </MenuItem>
                                )
                            })}
                        </SmallSelect>
                    </FormControl>
                
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <DateRangePickerComponent
                        initialStartDate={startDate}
                        initialEndDate={endDate}
                        ranges={{
                            "Last 7 Days": [moment().subtract(6, 'days'), moment()],
                            "This Month": [moment().startOf('month'), moment().endOf('month')],
                            "Last Month": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                            "Last 90 Days": [moment().subtract(89, 'days'), moment()],
                        }}
                        onDateRangeChange={handleDateRangeChange}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    {/* {isLoadingAlertNotification ? <Button><CircularProgress/></Button> 
                    : */}
                    <Button
                        onClick={(e) => handleExport(e)}
                        variant="contained"
                        startIcon= {isLoadingAlertNotification ? <CircularProgress sx={{color:'white'}} size={11} /> : <DownloadIcon />}
                        sx={{fontSize: 12, background: '#3333CFCE', color: '#fff', textTransform: 'none', "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                    >
                        {isLoadingAlertNotification ? "Exporting" : "Export"}
                    </Button>
                    {/* } */}
                </Grid>
            </Grid>

            <Grid item xs={12}>
                <Paper sx={{ width: '100%', overflow: 'hidden', mt: 3,  }}>
                    <TableContainer sx={{ border: "1px solid #3333cf54", borderRadius: 2, width: "100%", maxHeight: 600}}>
                        <Table stickyHeader sx={{ minWidth: 650, }}>
                            <ReportsTableHeader headers={headers} />

                            {isLoadingAlertList ? 
                                <TableBody>
                                    <AlertSkeleton/>
                                </TableBody>
                            :
                                <TableBody>
                                    {currentItems?.map((label, index) => (
                                        <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">
                                                {label.anomaly_id}
                                            </TableCell>

                                            <TableCell component="th" scope="row">
                                                {label?.alert_type}
                                            </TableCell>
                                            
                                            <TableCell component="th" scope="row">
                                                {label.verification_id}
                                            </TableCell>

                                            <TableCell component="th" scope="row">
                                                {label?.product_code}
                                            </TableCell>

                                            <TableCell component="th" scope="row">
                                                {label?.timestamp ? format(new Date(label?.timestamp), "PP"): 'N / A'}
                                            </TableCell>

                                            <TableCell component="th" scope="row">
                                                {label?.remarks ? label?.remarks : 'N / A'}
                                            </TableCell>

                                            <TableCell component="th" scope="row">
                                                N / A
                                            </TableCell>

                                            <TableCell component="th" scope="row">
                                                {label?.notification_method}
                                            </TableCell>

                                            <TableCell component="th" scope="row">
                                                {label?.user_email}
                                            </TableCell>

                                            <TableCell component="th" scope="row">
                                                {label?.user_type}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            }
                        </Table>

                        {/* ERROR MESSAGE */}
                        {!isLoadingAlertList && currentItems?.length === 0 && <Box sx={{textAlign:'center', m: 2}}> <Typography sx={{color:'gray', fontSize: 12}}>No data available.</Typography></Box>}
                        
                    </TableContainer>
                    {!isLoadingAlertList ?
                        <Box sx={{position:'sticky', zIndex: 1, display:'flex'}} justifyContent="center" mt={2} mb={2}>
                            <Pagination
                                count={totalPages}
                                page={page}
                                onChange={handlePageChange}
                                sx={{
                                    "& .MuiPaginationItem-root.Mui-selected": {
                                        color: "#fff",
                                        backgroundColor: "#5959D8"
                                    }
                                }} 
                            />
                        </Box>
                        : null}
                </Paper>
            </Grid>

            {/* DIALOG */}
            <ExportAlertNotificationDialog open={open} reportID={reportID} handleClose={handleClose}/>
        </Box>
        
    )

}

export default AlertsAndNotificationsFilterComponent